// Control/Input's control box (Figma 12:40) — 36px, px-12 py-8, radius 4.
// The label / help / error slots around it belong to <Field>, which is the
// same split the Figma component uses (its label and help are hidden slots
// on the filter/search usage).

import "./ui.css";
import type {
  InputHTMLAttributes,
  SelectHTMLAttributes,
  TextareaHTMLAttributes,
} from "react";

export type InputProps = InputHTMLAttributes<HTMLInputElement>;

export function Input({ className, ...rest }: InputProps) {
  return (
    <input
      {...rest}
      className={["maisight-ui-input", className].filter(Boolean).join(" ")}
    />
  );
}

export type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement>;

export function Textarea({ className, ...rest }: TextareaProps) {
  return (
    <textarea
      {...rest}
      className={["maisight-ui-input", "maisight-ui-textarea", className]
        .filter(Boolean)
        .join(" ")}
    />
  );
}

export type SelectOption = { value: string; label: string };

export type SelectProps = SelectHTMLAttributes<HTMLSelectElement> & {
  options: SelectOption[];
  /** Leading non-value option, e.g. "All statuses" on the documents filter. */
  placeholder?: string;
};

export function Select({ options, placeholder, className, ...rest }: SelectProps) {
  return (
    <select
      {...rest}
      className={["maisight-ui-select", className].filter(Boolean).join(" ")}
    >
      {placeholder ? <option value="">{placeholder}</option> : null}
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
}
